module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section",
    attrs: {
      "id": "section001"
    }
  }, [_c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "poem_title",
    attrs: {
      "id": "intro"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Behind the Isle—Translating Yi Lu")])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "jus"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("hile the tradition of pastoral poetry continues to be practiced in the West, few contemporary Chinese poets have grounded the corpus of their work and aesthetics in ecopoetics. In fact, ecocritical attention is scant. This is hardly a surprise, given the dominance of a Marxist ideology in favor of harnessing nature. Born in 1956 in Fujian province of southern China, Yi Lu"), _c('sup', [_c('span', {
    staticClass: "khide"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/text/Introduction#aintfn1"
    }
  }, [_vm._v("1")])])]), _c('sup', [_c('span', {
    staticClass: "ahide"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#kintfn1",
      "id": "krintfn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" started publishing her work in the eighties. Beyond the one-paragraph biography included here, not much is known about her life. She stands as a voice of her own, associated with neither a movement nor school of thought—certainly not under the flagship of political endorsement. This is no easy task, considering the context of a Communist state whose history and culture are engendered by Confucian ethics, Maoist discourse, and collective consciousness. Over the years, Yi’s work has steadily found its readership because of consistency and an engagement with ecology through language. Thoreau wrote, “We need the tonic of wildness . . . as [a] farm does loads of muck.” In taking this angle, Yi deviates from those who adopt a rhetoric based on Utilitarianism. She commits herself to poetry as the spiritual medium between language, nature, and science—a shifting paradigm that reconnects humanity with nature, this in spite of failures and tension in the inhabited time, space, imagination, or vision.")]), _vm._v(" "), _c('div', {
    staticClass: "khide"
  }, [_c('aside', {
    attrs: {
      "epub:type": "footnote",
      "id": "aintfn1"
    }
  }, [_vm._v("Yi is the poet’s family name. Most Chinese names consist of three characters or syllables. In this case, the poet goes by Yi Lu—with the surname preceding her first name, Lu—as her given name has only one character or syllable.")])]), _vm._v(" "), _c('p', {
    staticClass: "jusi"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("“An ecopoem,” as Nebraska-based James Engelhardt champions in a manifesto for ecopoetry, “might play with slippages, but the play will lead to further connections.”"), _c('sup', [_c('span', {
    staticClass: "khide"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/text/Introduction#aintfn2"
    }
  }, [_vm._v("2")])])]), _c('sup', [_c('span', {
    staticClass: "ahide"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#kintfn2",
      "id": "krintfn2"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("2")])])])]), _vm._v(" This offers a useful lens for reading Yi Lu, who in a preface for her award-winning volume, "), _c('em', [_vm._v("See")]), _vm._v(" (2004), provides a similar perspective of her oeuvre: “There are many things we can’t see. Not because they have yet to appear, but that we have not visibly connected with them.” To connect, to return—this is how she envisions a responsible life, a cognitive mind, as one that perceives the world, not as one that explains it. The linguistic effort to reach this intactness is a process of intimacy, mindful of the nonhuman, listening to silence. Ultimately, it seeks unity—to be "), _c('em', [_vm._v("in")]), _vm._v(", "), _c('em', [_vm._v("with")]), _vm._v(", and "), _c('em', [_vm._v("of")]), _vm._v(" an ever-evolving organic experience:")])]), _vm._v(" "), _c('div', {
    staticClass: "khide"
  }, [_c('aside', {
    attrs: {
      "epub:type": "footnote",
      "id": "aintfn2"
    }
  }, [_vm._v("This critical piece, “The Language Habitat: An Ecopoetry Manifesto” by James Engelhardt, appeared in the online poetry magazine "), _c('em', [_vm._v("Octopus")]), _vm._v(", Issue 9.")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('div', {
    staticClass: "inset_3"
  }, [_c('p', [_vm._v("touching its grass and trees   and petals")]), _vm._v(" "), _c('p', [_vm._v("my heart sways   a boat has left my body")]), _vm._v(" "), _c('p', [_vm._v("but why should I drift with the tide")]), _vm._v(" "), _c('p', [_vm._v("what relates me to this raft this water")]), _vm._v(" "), _c('p', [_vm._v("what links me with behind the isle")]), _vm._v(" "), _c('p', [_vm._v("what will unite at last")]), _vm._v(" "), _c('p', [_vm._v("—“Behind the Isle,” p. 49")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', {
    staticClass: "jusi"
  }, [_vm._v("Currently a resident in urban Fuzhou, the capital city of Fujian, Yi Lu is nostalgic for the sea and mountains: they incarnate specific landscapes and emotions that accompanied her during her childhood and through her young adulthood. When asked, in an interview, about her poetic origins, she vaguely recalls her teenage years during the Cultural Revolution"), _c('sup', [_c('span', {
    staticClass: "khide"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/text/Introduction#aintfn3"
    }
  }, [_vm._v("3")])])]), _c('sup', [_c('span', {
    staticClass: "ahide"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#kintfn3",
      "id": "krintfn3"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("3")])])])]), _vm._v(" (1966-1976), "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("and though her first poem was lost, it had “something to do with the sea.” She continued, “I saw in some children’s books beautiful illustrations of the sea, with clouds and in an azure blue, that looked totally different from those existing in my reality. I was probably inspired to write my ‘first’ poem because of this poignant longing for such clouds and sea.”"), _c('sup', [_c('span', {
    staticClass: "khide"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/text/Introduction#aintfn4"
    }
  }, [_vm._v("4")])])]), _c('sup', [_c('span', {
    staticClass: "ahide"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#kintfn4",
      "id": "krintfn4"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("4")])])])]), _vm._v(" Much has been written on how poets live and relive their childhood through poetry, but Yi’s account in this case informs us more about the recurring relevance of the sea in the poet’s work; it is as if the sea had defined her poetic vocation before she herself realized it. The title of the poem, “Sea First Man Next” is a self-explanatory allusion. In another, “No Prop Can Shield You,” the elusive "), _c('em', [_vm._v("you")]), _vm._v(" erases the personification of the sea, only to reinsert the “you” and the “sea” back into the theater of imagination to dramatic effects:")])]), _vm._v(" "), _c('div', {
    staticClass: "khide"
  }, [_c('aside', {
    attrs: {
      "epub:type": "footnote",
      "id": "aintfn3"
    }
  }, [_vm._v("During the Cultural Revolution, Yi Lu’s father was demoted from his governmental post and sent to the country for “re-education.” Yi spent her childhood in a village near “a gray, sinister sea.”")])]), _vm._v(" "), _c('div', {
    staticClass: "khide"
  }, [_c('aside', {
    attrs: {
      "epub:type": "footnote",
      "id": "aintfn4"
    }
  }, [_vm._v("From an unpublished interview with the translator (November 3, 2011).")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('div', {
    staticClass: "inset_2"
  }, [_c('p', [_vm._v("you are a prop")]), _vm._v(" "), _c('p', [_vm._v("used for contrast   perception")]), _vm._v(" "), _c('p', [_vm._v("people relax   free   or in a heavier daze")]), _vm._v(" "), _c('p', [_vm._v("now   you are a stirring wound   an eye full of tears")]), _vm._v(" "), _c('p', [_vm._v("no prop can shield you")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('div', {
    staticClass: "inset_2"
  }, [_c('p', [_vm._v("in the walls of a city")]), _vm._v(" "), _c('p', [_vm._v("thinking of you naked and far in the dark")]), _vm._v(" "), _c('p', [_vm._v("I’ll stay awake with you   this instant and next")]), _vm._v(" "), _c('p', [_vm._v("divided by the tossing and turning of an abyss")]), _vm._v(" "), _c('p', [_vm._v("—“No Prop Can Shield You,” p. 69")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', {
    staticClass: "jus"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("Here, the reversibility of “you”—from sea to a spectator (or the immediate reader?), then back to “I” the narrator/poet—is achieved without metaphor. The sea the poem, the poem the poet. The sea is for Yi Lu what the “Image” is for Ezra Pound: one that “presents an intellectual and emotional complex in an instant of time,” its “presentation” the release of “that sense of sudden liberation; that sense of freedom from time limits and space limits; that sense of sudden growth, which we experience in the presence of the greatest works of art.”"), _c('sup', [_c('span', {
    staticClass: "khide"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/text/Introduction#aintfn5"
    }
  }, [_vm._v("5")])])]), _c('sup', [_c('span', {
    staticClass: "ahide"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#kintfn5",
      "id": "krintfn5"
    }
  }, [_vm._v("5")])])]), _vm._v(" More narrative-driven “sea monologues” include “Drift Bottle,” “Many Many Mothers,” “My Own Sea,” “Using Two Seas,” and “A Dog on the Shore,” which are found in the second section of this bilingual collection. Even the book title "), _c('em', [_vm._v("Sea Summit")]), _vm._v(", chosen by Yi, is a symbolic gesture.")])]), _vm._v(" "), _c('div', {
    staticClass: "khide"
  }, [_c('aside', {
    attrs: {
      "epub:type": "footnote",
      "id": "aintfn5"
    }
  }, [_vm._v("Pound, Ezra. “A Retrospect.” "), _c('em', [_vm._v("Literary Essays of Ezra Pound")]), _vm._v(". Ed. T.S. Eliot. New York: New Directions, 1968. 4.")])]), _vm._v(" "), _c('p', {
    staticClass: "jusi"
  }, [_vm._v("By extension, virtually all her poems here carry a statement on, or illustration of, nature. Such is her call to arms for an aesthetic to reflect this identity—not by deference, but of belonging—the transcendence of a mortal existence in this universe. But Yi Lu is a reticent artist; to see Yi as a spokesperson for ecological causes undercuts the lyrical vitality of the poems. For her, writing functions more as an experience of feeling "), _c('em', [_vm._v("chez soi")]), _vm._v(" than the endeavor of creating another home. In her work, you can read patience: a gentle ritual of each verse peeling an image away, moment by moment—as slow as possible but with surprising turns. Even the gentlest poem has its rigor: it controls its forward momentum. The most unforgettable ones are often hesitant to settle for emotional resolution by a clean stroke. Also, the speaker in these poems elucidates moral truth with tenderness. I like this ethics: the poet takes care of the reader.")]), _vm._v(" "), _c('p', {
    staticClass: "jusi"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("Yi Lu is a theater scenographer and set designer by profession. The challenge for a scenographer is the interpretation of space, "), _c('em', [_vm._v("creating suggestive space and linking space with dramatic time")]), _vm._v("."), _c('sup', [_c('span', {
    staticClass: "khide"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/text/Introduction#aintfn6"
    }
  }, [_vm._v("6")])])]), _c('sup', [_c('span', {
    staticClass: "ahide"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#kintfn6",
      "id": "krintfn6"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("6")])])])]), _vm._v(" As stage designer, she is ranked “national first-level.” She is also a painter. Naturally, colors and visual form offer immediate choices that help her to "), _c('em', [_vm._v("visually liberate the text")]), _vm._v("."), _c('sup', [_c('span', {
    staticClass: "khide"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/text/Introduction#aintfn7"
    }
  }, [_vm._v("7")])])]), _c('sup', [_c('span', {
    staticClass: "ahide"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#kintfn7",
      "id": "krintfn7"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("7")])])])]), _vm._v(" She thinks of geometry as a measure of mood. Without sentimentalism, or extravagant verbalism, her work speaks, in an image-driven language, to the transience of matter. I consider Yi Lu a quiet poet who says something “shapeful,” yet precise. To question the role of a (post-)modern human existence in a larger cosmos, she evokes and invokes nature in its grandeur or small moments, but with a philosophically inquiring mind. The agenda does not stop at celebration:")])]), _vm._v(" "), _c('div', {
    staticClass: "khide"
  }, [_c('aside', {
    attrs: {
      "epub:type": "footnote",
      "id": "aintfn6"
    }
  }, [_vm._v("Howard, Pamela. "), _c('em', [_vm._v("What Is Scenography?")]), _vm._v(" London: Routledge, 2002. 1.")])]), _vm._v(" "), _c('div', {
    staticClass: "khide"
  }, [_c('aside', {
    attrs: {
      "epub:type": "footnote",
      "id": "aintfn7"
    }
  }, [_vm._v("“The scenographer visually liberates the text and the story behind it, by creating a world in which the eyes see what the ears do not hear.” "), _c('em', [_vm._v("Ibid")]), _vm._v(", 33.")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('div', {
    staticClass: "inset_3"
  }, [_c('p', [_vm._v("the world has many lakes")]), _vm._v(" "), _c('p', [_vm._v("some frozen   some boiling at a volcano’s peak")]), _vm._v(" "), _c('p', [_vm._v("some saltier than seawater")]), _vm._v(" "), _c('p', [_vm._v("most fresh and cool, green and pleasing")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('div', {
    staticClass: "inset_3"
  }, [_c('p', [_vm._v("stillness is self weighing on self")]), _vm._v(" "), _c('p', [_vm._v("many things controlled unwittingly")]), _vm._v(" "), _c('p', [_vm._v("—“Lake, Again,” p. 179")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', {
    staticClass: "jusi"
  }, [_vm._v("Birds and trees populate Yi Lu’s imagination, as she writes and creates art from her study with a window facing a sturdy tree. A curious observer of the tree’s “bird visitors,” Yi wakes up to their call, and begins "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("her day with a sense of awe. What is profundity but the gestation of "), _c('em', [_vm._v("listen")]), _vm._v("? She waits for birds and the tree to speak to her. The act in its essence is a proof of faith. To chronicle surprises that birds bring her in the day is the extension of this ritual witnessing of the nonhuman. The experience is both restorative and sacred, short of permanence but filled with effort:")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('div', {
    staticClass: "inset_3"
  }, [_c('p', [_vm._v("a treeful of bird calls like starlight   like scissors   like nails")]), _vm._v(" "), _c('p', [_vm._v("[. . .]")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('div', {
    staticClass: "inset_3"
  }, [_c('p', [_vm._v("in my body rooms emerge one by one")]), _vm._v(" "), _c('p', [_vm._v("one by one rooms emerge with bells")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('div', {
    staticClass: "inset_3"
  }, [_c('p', [_vm._v("I’m like a treeful of bird calls")]), _vm._v(" "), _c('p', [_vm._v("wake up   dress   exercise   freshen up")]), _vm._v(" "), _c('p', [_vm._v("I jingle like a treeful of bird calls")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('div', {
    staticClass: "inset_3"
  }, [_c('p', [_vm._v("light   and expand my rooms one by one")]), _vm._v(" "), _c('p', [_vm._v("like a treeful of bird calls I’m fully lit   ready to work")]), _vm._v(" "), _c('p', [_vm._v("—“A Treeful of Bird Calls,” p. 29")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('p', {
    staticClass: "jusi"
  }, [_vm._v("Literary critics in China make frequent reference to Yi Lu’s word-by-word elegance, and how it runs in counterpoint with a theatrical texture. Within a poem, these two trademarks play a role in molding an architecture—both visual and formal—that is distinctly hers. Asymmetrical yet with a natural poise, her verses expand lyrical possibilities while keeping intact the density of a personal narrative. Words in a verse behave like notes, each with a sound before coming together as a string of meanings. Cadence, or movement, pulls and pushes each line, creating a playfulness between space and verse. The "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("impact of a trompe-l’œil is accentuated when the writing tames itself into a miniature visual artwork. And it becomes what we may recognize as a calligram or a word-shaped poem:")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('div', {
    staticClass: "inset_3"
  }, [_c('p', [_vm._v("bird calls play on the mountainside")]), _vm._v(" "), _c('p', [_vm._v("tug at clouds")]), _vm._v(" "), _c('p', [_vm._v("widen the coil of light")]), _vm._v(" "), _c('p', [_vm._v("crack it")]), _vm._v(" "), _c('p', [_vm._v("transfigure it")]), _vm._v(" "), _c('p', [_vm._v("avoid neatness")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('div', {
    staticClass: "inset_3"
  }, [_c('p', [_vm._v("bird calls guide the way for the lazy slow spring")])]), _vm._v(" "), _c('div', {
    staticClass: "inset_4"
  }, [_c('p', [_vm._v("like a flight of stairs they fall")])]), _vm._v(" "), _c('div', {
    staticClass: "inset_5"
  }, [_c('p', [_vm._v("like a flight of stairs they fall")])]), _vm._v(" "), _c('div', {
    staticClass: "inset_6"
  }, [_c('p', [_vm._v("like a flight of stairs they fall")])]), _vm._v(" "), _c('div', {
    staticClass: "inset_3"
  }, [_c('p', [_vm._v("—“Bird Call on a Spring Day,” p. 121")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', {
    staticClass: "jusi"
  }, [_vm._v("Overall, Yi Lu communicates from a bodied relation to sound and image. Conscious of how the spatial arrangement of words on a page may affect their sonic effect, she believes disparate words in a poem have a greater need for independence than musical notes in terms of implications."), _c('sup', [_c('span', {
    staticClass: "khide"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/text/Introduction#aintfn8"
    }
  }, [_vm._v("8")])])]), _c('sup', [_c('span', {
    staticClass: "ahide"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#kintfn8",
      "id": "krintfn8"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("8")])])])]), _vm._v(" Punctuation free, the poems generate a different dynamic that encourages more choices in diction. A pause or a sound is at once detail and event. In lieu of commas or periods, she substitutes indent spacings, each resembling an empty space on the stage. Words become the actors. In turn, volatility is introduced; as a juncture between ideas or temporality, blank spacings embody the potential of enjambments, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("interruptives, and disjunctions. Emptiness is responsive in this internal jazz that externalizes the leap from one image to another. I cannot resist the thought of such aesthetics pledging allegiance to the poet’s cross-disciplinary practice in theater, dramaturgy, and set design. The opening stanza of “Space of Drama” is particularly resonant:")])]), _vm._v(" "), _c('div', {
    staticClass: "khide"
  }, [_c('aside', {
    attrs: {
      "epub:type": "footnote",
      "id": "aintfn8"
    }
  }, [_vm._v("From an unpublished interview with the translator (November 3, 2011).")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('div', {
    staticClass: "inset_2"
  }, [_c('p', [_vm._v("word   phrase   period—")]), _vm._v(" "), _c('p', [_vm._v("a mountain stream   a lofty mountain range   a monastery")]), _vm._v(" "), _c('p', [_vm._v("from far to near")]), _vm._v(" "), _c('p', [_vm._v("abyss hangs in mid-sky   visible in all directions")]), _vm._v(" "), _c('p', [_vm._v("a wave   kowtows before the ocean")]), _vm._v(" "), _c('p', [_vm._v("mountain peaks buried under the sea")]), _vm._v(" "), _c('p', [_vm._v("—“Space of Drama,” p. 197")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', {
    staticClass: "jusi"
  }, [_vm._v("During the translation of "), _c('em', [_vm._v("Sea Summit")]), _vm._v(", I found some help from an observation by American poet Jane Hirshfield:")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("A person’s heard voice is replete with information. So it is with the voice of a poem, directing us in myriad ways into the realm it inhabits—a realm more or less formal, more or less argumentative, more or less emotional, linear, textured. As we gauge a person’s kindness by tone, regardless of what she is saying, we similarly recognize a poem’s tenderness or harshness toward the world around it; its engagement or detachment . . ."), _c('sup', [_c('span', {
    staticClass: "khide"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/text/Introduction#aintfn9"
    }
  }, [_vm._v("9")])])]), _c('sup', [_c('span', {
    staticClass: "ahide"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#kintfn9",
      "id": "krintfn9"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('div', {
    staticClass: "khide"
  }, [_c('aside', {
    attrs: {
      "epub:type": "footnote",
      "id": "aintfn9"
    }
  }, [_vm._v("Hirshfield, Jane. “Poetry and the Mind of Concentration.” "), _c('em', [_vm._v("Nine Gates: Entering the Mind of Poetry")]), _vm._v(". New York: HarperCollins Publishers, 1998. 29.")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', {
    staticClass: "jus"
  }, [_vm._v("Inspired to locate the tone, and to follow the breath of the thought behind each verse, I thus asked Yi Lu to read the poems aloud during our weekly "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("Skype meetings. There are instances of quiet, defense, surrender, and anticipation, all of which seek translation and to be determined by the intensity of listening. However, I am reluctant to focus on the process of translation—its worthy accidents, defeats, and investigations—instead of the poetry and its ecological literacy. This might have something to do with a moral impulse from an era when our children must confront industrial toxins in their daily life. At the same time, astute citizens might grow conscious of a political and cultural “trendiness” to ecological concerns in America or Europe today. It makes me anxious to think of us reading Yi Lu simply as a departure point for discussions on ecopoetics. To introduce her as first a poet, next a woman poet, then a lyrical poet and an “eco-poet” is thus less an attempt at seeking a singular audience than an experiment to transport these “labels” to another culture or reality. What does it mean to have a poet—a woman, a mother, in a country of more than 1.3 billion—address our increasingly catastrophic attitudes toward nature and its imbalance, and to do so in China’s difficult and politically determined culture? What does it signify for China and the rest of the world?")])]), _vm._v(" "), _c('p', {
    staticClass: "jusi"
  }, [_c('em', [_vm._v("Sea Summit")]), _vm._v(" compiles Yi Lu’s work over a span of more than two decades. It includes poems from four of her five volumes. While Yi Lu began publishing her writings in 1984, her debut collection, "), _c('em', [_vm._v("On the Cusp of Youth")]), _vm._v(", appeared only in 1991. The second, "), _c('em', [_vm._v("Voyage")]), _vm._v(", was published by the national press in Beijing, The Writers’ Publishing House, in 1997. It took another seven years before a third book, "), _c('em', [_vm._v("See")]), _vm._v(" (2004), materialized. The union of nature and symbolic vision—what Yi Lu defines as “the unseen limit”—is a thematic concern in "), _c('em', [_vm._v("See")]), _vm._v(" as well as "), _c('em', [_vm._v("Using Two Seas")]), _vm._v(" (2009). Her fifth volume, "), _c('em', [_vm._v("Forever Lingering")]), _vm._v(" (2011), contains new sequenced poems that evolve from earlier narratives in "), _c('em', [_vm._v("See")]), _vm._v(". As I write, I think of Rilke: “The great poetry begins in elegy and ends in praise.” "), _c('em', [_vm._v("Sea Summit")]), _vm._v(" begins in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("elegiac speculation—“even the butterfly seems unrelated to itself”—and ends with a wish, "), _c('em', [_vm._v("May you see the splendor of stars in this world")]), _vm._v(". It is not the cliché but a sense of awakening that this language of praise creates.")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', {
    staticClass: "right_text"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IONA")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ZE")]), _vm._v("-L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORRAIN")])]), _vm._v(" "), _c('div', {
    staticClass: "ahide"
  }, [_c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_c('img', {
    attrs: {
      "alt": "[image: cover]",
      "height": "2",
      "src": "images/line.jpg",
      "width": "110"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#krintfn1",
      "id": "kintfn1"
    }
  }, [_vm._v("1")]), _vm._v("   Yi is the poet’s family name. Most Chinese names consist of three characters or syllables. In this case, the poet goes by Yi Lu—with the surname preceding her first name, Lu—as her given name has only one character or syllable.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#krintfn2",
      "id": "kintfn2"
    }
  }, [_vm._v("2")]), _vm._v("   This critical piece, “The Language Habitat: An Ecopoetry Manifesto” by James Engelhardt, appeared in the online poetry magazine "), _c('em', [_vm._v("Octopus")]), _vm._v(", Issue 9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#krintfn3",
      "id": "kintfn3"
    }
  }, [_vm._v("3")]), _vm._v("   During the Cultural Revolution, Yi Lu’s father was demoted from his governmental post and sent to the country for “re-education.” Yi spent her childhood in a village near “a gray, sinister sea.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#krintfn4",
      "id": "kintfn4"
    }
  }, [_vm._v("4")]), _vm._v("   From an unpublished interview with the translator (November 3, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#krintfn5",
      "id": "kintfn5"
    }
  }, [_vm._v("5")]), _vm._v("   Pound, Ezra. “A Retrospect.” "), _c('em', [_vm._v("Literary Essays of Ezra Pound")]), _vm._v(". Ed. T.S. Eliot. New York: New Directions, 1968. 4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#krintfn6",
      "id": "kintfn6"
    }
  }, [_vm._v("6")]), _vm._v("   Howard, Pamela. "), _c('em', [_vm._v("What Is Scenography?")]), _vm._v(" London: Routledge, 2002. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#krintfn7",
      "id": "kintfn7"
    }
  }, [_vm._v("7")]), _vm._v("   “The scenographer visually liberates the text and the story behind it, by creating a world in which the eyes see what the ears do not hear.” "), _c('em', [_vm._v("Ibid")]), _vm._v(", 33.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#krintfn8",
      "id": "kintfn8"
    }
  }, [_vm._v("8")]), _vm._v("   From an unpublished interview with the translator (November 3, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#krintfn9",
      "id": "kintfn9"
    }
  }, [_vm._v("9")]), _vm._v("   Hirshfield, Jane. “Poetry and the Mind of Concentration.” "), _c('em', [_vm._v("Nine Gates: Entering the Mind of Poetry")]), _vm._v(". New York: HarperCollins Publishers, 1998. 29.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f00246","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Introduction.vue
// module id = 81
// module chunks = 0